import React from 'react';
import cn from 'classnames';
import styles from './Popup.scss';

const Popup = ({ className, isOpen, render }) => (
      isOpen ?
        <div className={cn(styles.Popup, className)}>
          <div className={styles.Content}>
            {render ? render() : null}
          </div>
        </div> :
      null
  );

export default Popup;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Popup/Popup.js